import { request as __request } from '../core/request.js';
export class ActivityService {
    /**
     * Get an account's activity
     * Returns paginated activity in reverse order (most recent first).
     *
     * Activity is an immutable event log. Every single account event yields an activity object.
     *
     * The API key used to access this method affects what activity rows are returned: activity rows
     * corresponding to test orders for the test API key, the rest of the rows (both activity rows
     * corresponding to live orders or not having any order associated with them) for the live API key.
     *
     * @param limit Maximum number of resources to return, between 1 and 100.
     *
     * @param after A cursor for use in pagination.
     *
     * *after* is an object ID that defines your place in the list.
     *
     * For instance, if you make a list request and receive 100 objects, ending with *foo*, your subsequent call can include *after=foo* in order to fetch the next page of the list.
     *
     * @returns PaginatedActivity The response returns paginated activity
     */
    getActivity(limit = '10', after) {
        return __request(this.client, this.config, {
            method: 'GET',
            url: '/activity',
            query: {
                limit: limit,
                after: after,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized. The API Key is invalid or disabled.`,
                429: `Rate limit exceeded`,
            },
        });
    }
}
//# sourceMappingURL=ActivityService.js.map